// Load Styles
import '../../../scss/page/product/car.scss';

const sm = window.matchMedia('(min-width: 0px) and (max-width: 767px)' );
const md = window.matchMedia( '(min-width: 768px) and (max-width: 991px)' );
const lg = window.matchMedia( '(min-width: 992px) and (max-width: 1279px)' );
const xl = window.matchMedia( '(min-width: 1280px)' );
const mainNavigation = document.getElementById( 'primary-main-navbar' );
const mainNavigationHeight = mainNavigation.getBoundingClientRect().height;
const body = document.querySelector( 'body' );
const header = document.querySelector( '#header' );
const headerHeight = header.getBoundingClientRect().height;
const footerQuoteButtonGroup =document.querySelector( '#footer-quote-button-group' );
const buttonBackToTop = document.querySelector( '#button-back-to-top' );
const stickyAsideTrigger = document.querySelector( '#sticky-aside-container-trigger' );
const unstickyAsideTrigger = document.querySelector( '#unsticky-aside-container-trigger' );
const unstickyAsideTriggerEl = document.getElementById( 'unsticky-aside-container-trigger' );
const asideQuoteButtonGroup = document.querySelector( '#aside-quote-button-group' );
const asideQuoteButtonGroupHeight = asideQuoteButtonGroup.getBoundingClientRect().height;
const asideContainer = document.querySelector( '#aside-container' );
const asideStickyBottomMargin = -window.innerHeight + (mainNavigationHeight + asideQuoteButtonGroupHeight + 32);
const unstickyInset = (unstickyAsideTrigger.getBoundingClientRect().top - 32);
const documentBody = document.body.getBoundingClientRect();

let prevScrollY = 0;
let scrollDirection;
let firstStart = true;


/**
 * 
 */
const benefits_el = document.querySelector( '#benefits-swiper' );
const rows = benefits_el.getAttribute( 'data-rows' );

const benefits_swiper = new Swiper( '#benefits-swiper', {
  breakpoints: {
    0: {
      slidesPerView: 1.3,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1200: {
      slidesPerView: 2.5,
      spaceBetween: 8,
    },
  },

  grid: {
    rows: parseInt( rows ),
    fill: 'row',
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
} );

const brands_swiper = new Swiper( '#brands-swiper', {
  breakpoints: {
    0: {
      slidesPerView: 1.8,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1200: {
      slidesPerView: 3.3,
      spaceBetween: 16,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
} );

const how_to_buy_swiper = new Swiper( '#how-to-buy-swiper', {
  breakpoints: {
    0: {
      slidesPerView: 1.4,
      spaceBetween: 16 ,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1200: {
      slidesPerView: 2.5,
      spaceBetween: 16,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
} );

const feefo_reviews_swiper = new Swiper( '#feefo-reviews-swiper', {
  breakpoints: {
    0: {
      slidesPerView: 1.4,
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1200: {
      slidesPerView: 2.5,
      spaceBetween: 8,
    },
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
} );


/**
 * 
 */
const backToTopObserver = new IntersectionObserver( ( entries, observer ) => {
  entries.forEach( entry => {
    if ( entry.isIntersecting ) {
      buttonBackToTop.classList.add( 'fade' );

      prevScrollY = window.scrollY;

    } else {
      buttonBackToTop.classList.remove( 'fade' );

      prevScrollY = window.scrollY;
    }
  } );
}, {
  root: null,
  rootMargin: '-' + mainNavigationHeight.toString() + 'px 0px 0px 0px',
  threshold: 0
} );

backToTopObserver.observe( header );


/**
 * 
 */
const header_observer = new IntersectionObserver( ( entries, observer ) => {
  entries.forEach( entry => {
    if ( entry.isIntersecting ) {
      if ( entry.target.id === 'header' ) {
        body.classList.remove( 'footer-quote-button-group-expanded' );

        buttonBackToTop.classList.add( 'fade' );
      }

      if ( entry.target.id === 'unsticky-aside-container-trigger' ) {
        body.classList.remove( 'footer-quote-button-group-expanded' );
      }

      prevScrollY = window.scrollY;

    } else {
      if ( entry.target.id === 'header' ) {
        if (!firstStart) {
          body.classList.add( 'footer-quote-button-group-expanded' );

          buttonBackToTop.classList.remove( 'fade' );
        }
      }

      if ( entry.target.id === 'unsticky-aside-container-trigger' &&  ( window.scrollY <= prevScrollY ) ) {
        if (!firstStart) {
          body.classList.add( 'footer-quote-button-group-expanded' );
        }
      }

      prevScrollY = window.scrollY;
    }
  } );
}, {
  root: null,
  rootMargin: '-' + mainNavigationHeight.toString() + 'px 0px 0px 0px',
  threshold: 0
} );

if (sm.matches || md.matches) {
  header_observer.observe( header );
  header_observer.observe( unstickyAsideTrigger );

} else {
  header_observer.unobserve( header );
  header_observer.unobserve( unstickyAsideTrigger );
}

/**
 * 
 */
window.addEventListener( 'load resize', function() {
  // prevScrollY = window.scrollY;
} )

const aside_observer = new IntersectionObserver( ( entries, observer ) => {
  entries.forEach( entry => {
    if ( entry.isIntersecting ) {
      if ( entry.target.id === 'unsticky-aside-container-trigger' &&  ( window.scrollY >= prevScrollY ) ) {
        asideContainer.style.position = 'absolute';
        asideContainer.style.left = '0';
        asideContainer.style.top = (unstickyAsideTrigger.getBoundingClientRect().top - stickyAsideTrigger.getBoundingClientRect().top + mainNavigationHeight + headerHeight - (asideQuoteButtonGroupHeight + 32) ).toString() + 'px';
      }

      prevScrollY = window.scrollY;

    } else {
      if ( entry.target.id === 'sticky-aside-container-trigger' &&  ( window.scrollY >= prevScrollY ) ) {
        asideContainer.style.position = 'sticky';
        asideContainer.style.top = mainNavigationHeight.toString() + 'px';
        asideContainer.style.left = '0';

      } 
      
      if ( entry.target.id === 'unsticky-aside-container-trigger' &&  ( window.scrollY <= prevScrollY ) ) {
        asideContainer.style.position = 'sticky';
        asideContainer.style.top = mainNavigationHeight.toString() + 'px';
        asideContainer.style.left = '0';
      }

      if ( entry.target.id === 'unsticky-aside-container-trigger' &&  ( window.scrollY > ( unstickyAsideTriggerEl.offsetTop - asideQuoteButtonGroupHeight) ) ) {
        asideContainer.style.position = 'absolute';
        asideContainer.style.left = '0';
        asideContainer.style.top = (unstickyAsideTrigger.getBoundingClientRect().top - stickyAsideTrigger.getBoundingClientRect().top + mainNavigationHeight + headerHeight - (asideQuoteButtonGroupHeight + 32) ).toString() + 'px';
      }

      prevScrollY = window.scrollY;
    } 
  } );
}, {
  root: null,
  rootMargin: '-' + mainNavigationHeight.toString() + 'px 0px ' + asideStickyBottomMargin.toString() + 'px 0px',
  threshold: 0
} );

if (sm.matches || md.matches) {
  aside_observer.unobserve( stickyAsideTrigger );
  aside_observer.unobserve( unstickyAsideTrigger );

} else if (lg.matches || xl.matches) {
  aside_observer.observe( stickyAsideTrigger );
  aside_observer.observe( unstickyAsideTrigger );
}


function wrapElement( element, inset, height ) {
  const clone = element.cloneNode(true);
  const inner = document.createElement('div');
	const outer = document.createElement('div');

  inner.appendChild(clone);
  inner.style.position = 'fixed';
  inner.style.width = '100%';
  inner.style.inset = inset;

  element.replaceWith(inner);

  const cloneInner = inner.cloneNode(true);

  outer.appendChild(cloneWrapper);
  outer.style.position = 'relative';
  outer.style.height = inset + 'px';
  outer.style.minHeight = inset + 'px';

  inner.replaceWith(outer);

  return outer;
}


/**
 * 
 */
buttonBackToTop.addEventListener( 'click', function() {
  scrollPageTo( 0 );
} );

function scrollPageTo( to, duration = 600 ) {
  const easeOutQuad = function ( t, b, c, d ) {
    t /= d;
    return -c * t * ( t - 2 ) + b;
  };

  return new Promise( ( resolve, reject ) => {
    const element = document.scrollingElement;

    if ( typeof to === 'string' ) {
      to = document.querySelector( to ) || reject();
    }

    if ( typeof to !== 'number' ) {
      to = to.getBoundingClientRect().top + element.scrollTop;
    }

    let start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    const animateScroll = function() {
      currentTime += increment;

      let val = easeOutQuad( currentTime, start, change, duration );

      element.scrollTop = val;

      if ( currentTime < duration ) {
        setTimeout( animateScroll, increment );

      } else {
        resolve();
      }
    };

    animateScroll();
  });
};

/**
 * 
 */
window.addEventListener( 'load', function() {
  console.log(documentBody.y);
  console.log(unstickyAsideTrigger.getBoundingClientRect().top);
  console.log(window.scrollY);
} );

window.addEventListener( 'scroll', function() {
  if ( firstStart ) {
    firstStart = false;
  }
} );